import { accDiv } from '@/utils/math'

// 分转元
export default function fenToYuan (num) {
  if (num === undefined || num === null || num === '') {
    return num
  }
  return accDiv(num, 100)
}
